import { DatePicker, Tooltip } from 'antd';
import React from 'react';
import styles from './DateExcess.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { setDateExcess } from '../../../../../../store/actions/housingStockActions';

const DateExcess = () => {
  const dispatch = useDispatch();

  const dateExcess = useSelector((state) => state.housingStockStore.dateExcess);

  const onChange = (date) => {
    dispatch(setDateExcess(!!date ? date.format() : null));
  };

  return (
    <Tooltip title="Плановая дата выполнения превышает:">
      <DatePicker
        onChange={onChange}
        value={!!dateExcess ? moment(dateExcess) : null}
        allowClear={true}
        placeholder="Проверочная дата"
        size="large"
        format="DD.MM.YYYY"
        className={styles.root}
        style={{ width: 300 }}
      />
    </Tooltip>
  );
};

export default DateExcess;
